import webshop from '@wwdev/webshop';
import Bindings from "@wwdev/webshop/bindings";
import Variants from "@wwdev/webshop/variants";
import Popup from '@wwdev/webshop/popup';
import "./filter";
import "./Indicator";

webshop.basket.updateQuantity = function (e) {
	let $element = $(e.currentTarget);
	$.ajax({
		url: $element.attr("data-href"),
		method: "post",
		data: {
			productId: $element.attr("data-id"),
			quantity: $element.val(),
			action: "update_product_quantity"
		},
		success: this.onUpdateQuantitySuccess.bind(this)
	})
}

webshop.basket.onUpdateQuantitySuccess = function(response) {
	window.location.reload();
}

webshop.basket.init();
webshop.shipping.init();

(new Popup).init();

Bindings.init();

Variants.init();
